import { atom } from 'recoil';

export const Order = atom({
    key: 'order',
    default: {
        name: 'default',
        items: [],
        orderNo: 4633,
    }
})